export default __webpack_public_path__ + "static/lalibrairie-m-mobile@2x-cd018fa440bbf8c8557ae7b164f43f9e.jpg";